import React, { useMemo } from "react";
import SourceVariable from "../SourceVariable";
import * as styles from "./styles.module.scss";
const GraphSourcesLabels = ({ sources }) => {
    const visibleSources = useMemo(() => sources?.filter(({ view }) => view) ?? [], [sources]);
    return (React.createElement("div", { className: styles.root }, visibleSources.map((source, index) => {
        const colorIndex = sources?.findIndex(({ id }) => id === source?.id) ?? 0;
        return (React.createElement(SourceVariable, { key: index, source: source, index: index, colorIndex: colorIndex, className: styles[`variable-${visibleSources.length}`] }));
    })));
};
export default GraphSourcesLabels;
